export const routes = {
  login: "/",
  notification: "/notifications",
  notification2: "/notification2s",
  dashboard: "/dashboard",
  changePassword:"/changePassword",
  orderDetailsShipment: "/readyForShipmentOrderDetails",
  orderDetailsInProgress: "/inProgressOrderDetails",
  newOrderDetails: "/newOrderDetails",
  deliveryOrderDetails: "/outForDeliveryOrderDetails",
  printPackagingSlip: "/printPackagingSlip",
  pastOrders: "/pastOrders",
  pastOrderDetails: "/pastOrderDetails",
  servicePackagingSlips:"/packagingSlip"
};
